import React from "react";
import { Link } from "react-router-dom";
import { FaMoneyBillWave, FaQrcode, FaShieldAlt,FaChevronLeft ,FaLock } from "react-icons/fa";
import "./easypaisa.css";
import { useNavigate } from "react-router-dom";


const EasyPaisa = () => {
    const navigate = useNavigate();
  
  const paymentMethods = [
    {
      id: 1,
      title: "Manual Payment",
      icon: <FaMoneyBillWave className="method-icon" />,
      description: "Enter payment details manually",
      route: "/jazzcashmu",
      features: [
        "Direct account transfer",
        "Payment via reference number",
        "Instant processing"
      ]
    },
    {
      id: 2,
      title: "QR Payment",
      icon: <FaQrcode className="method-icon" />,
      description: "Scan to pay instantly",
      route: "/jazzcashqr",
      features: [
        "Secure QR code scanning",
        "Auto-filled payment details",
        "Faster processing"
      ]
    }
  ];

  return (
    <div className="ep-payment-container">
      <div className="ep-payment-header">
       <button className="gb-back-button" onClick={() => navigate(-1)}>
                <FaChevronLeft className="icon" /> BACK
              </button>
        
        <div className="ep-brand-header">
          <img 
            src="./images/new-Jazzcash-logo.png" 
            alt="EasyPaisa" 
            className="ep-brand-logo"
            onError={(e) => {
              e.target.onerror = null; 
              e.target.src = "./images/payment-default.png";
            }}
          />
          <h1>JazzCash PAYMENT</h1>
        </div>
        <div className="ep-security-badge">
          <FaLock className="icon" /> SECURE PAYMENT GATEWAY
        </div>
      </div>

      <div className="ep-payment-content">
        <div className="ep-payment-intro">
          <h2>Select Payment Method</h2>
          <p className="ep-payment-subtext">
            <FaShieldAlt className="icon" /> All transactions are encrypted with bank-level security
          </p>
        </div>

        <div className="ep-method-grid">
          {paymentMethods.map((method) => (
            <Link to={method.route} className="ep-method-card" key={method.id}>
              <div className="ep-method-header">
                <div className="ep-method-icon">
                  {method.icon}
                </div>
                <h3>{method.title}</h3>
              </div>
              <p className="ep-method-description">{method.description}</p>
              
              <ul className="ep-method-features">
                {method.features.map((feature, index) => (
                  <li key={index}>
                    <span className="ep-feature-bullet">•</span> {feature}
                  </li>
                ))}
              </ul>

              <div className="ep-select-button">
                SELECT THIS METHOD
              </div>
            </Link>
          ))}
        </div>

        <div className="ep-security-section">
          <div className="ep-security-feature">
            <div className="ep-security-icon">
              <FaLock />
            </div>
            <div>
              <h4>100% Secure Transactions</h4>
              <p>Your payment details are always protected</p>
            </div>
          </div>
          <div className="ep-security-feature">
            <div className="ep-security-icon">
              <FaShieldAlt />
            </div>
            <div>
              <h4>Instant Coin Delivery</h4>
              <p>Coins added immediately after successful payment</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasyPaisa;